/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const ImportBalanceJsonApiModel = {
  id: "",
  import: {
    jsonApi: "hasOne",
    type: "imports",
  },
  "external-id": "",
  row: "",
  status: "",
  errors: "",
  metadata: "",
  "created-at": "",
  "updated-at": "",
  "account-id": "",
  "client-position-id": "",
  "holding-id": "",
  "account-name": "",
  "as-of-date": "",
  "capital-account-balance": "",
  "market-value": "",
  "net-capital-contributions": "",
  units: "",
  "unit-price": "",
  "unit-price-date": "",
  "paid-to-date": "",
  rate: "",
};
